import type { PavementBucket, PavementSegment, RouteMetricsResult } from '../api';

const BUCKET_COLORS: Record<PavementBucket, string> = {
  ASPHALT: '#546e7a',
  OTHER_PAVED: '#8d9ba3',
  UNPAVED: '#b08968',
  UNKNOWN: '#3a4a5a',
};

/**
 * Gradiente de pavimento — mismo truco de stops "duros" que `speedZones.ts`
 * usa para Velocidades (dos puntos casi idénticos en el límite de cada
 * tramo para que `line-gradient` no interpole entre tipos de superficie
 * vecinos). `segments` viene ya en metros acumulados desde el backend
 * (`RouteMetricsResult.pavement.segments`), no requiere una segunda fuente
 * de geometría.
 */
export function buildPavementGradientStops(segments: PavementSegment[], totalLengthM: number): Array<[number, string]> {
  if (!totalLengthM || segments.length === 0) return [];
  const stops: Array<[number, string]> = [];
  for (const seg of segments) {
    const color = BUCKET_COLORS[seg.bucket];
    const p0 = Math.max(0, Math.min(1, seg.startM / totalLengthM));
    const p1 = Math.max(p0, Math.min(1, seg.endM / totalLengthM));
    stops.push([p0, color]);
    stops.push([Math.max(p0, p1 - 0.00001), color]);
  }
  return stops;
}

export function pavementStopsForRoute(metrics: RouteMetricsResult | null): Array<[number, string]> {
  if (!metrics) return [];
  return buildPavementGradientStops(metrics.pavement.segments, metrics.pavement.totalLengthM);
}
